import { useMutation, useQuery } from "@tanstack/react-query";
import { message, Space } from "antd";
import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "@rumbledirect/ui";
import {
  deleteConceptById,
  fetchConcepts,
} from "@/lib/api/resources/dossierConcepts";
import { conceptColumns } from "../lib/constants/conceptColumns";
import { Table } from "@/components/v2";
import { CreateConceptModal } from "./components/CreateConceptModal";

export const ConceptsList = () => {
  const [page, setPage] = useState(1);
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const conceptsQuery = useQuery({
    queryKey: ["concepts", page],
    queryFn: () =>
      fetchConcepts({
        dossierTypeName: "repair_direct.generic",
        page: page,
      }),
  });

  const deleteConceptMutation = useMutation({
    mutationFn: async (conceptId: string) => deleteConceptById(conceptId),
    onSuccess: () => {
      message.success("Concept succesvol verwijderd");
      conceptsQuery.refetch();
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van het concept.",
      ),
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Button
          icon={<PlusOutlined />}
          onClick={() => setCreateModalOpen(true)}
        >
          Nieuw concept
        </Button>
      </Space>
      <Table
        dataSource={conceptsQuery.data?.member}
        columns={conceptColumns(deleteConceptMutation)}
        loading={conceptsQuery.isFetching}
        pagination={{
          pageSize: 15,
          total: conceptsQuery.data?.totalItems,
          showSizeChanger: false,
          onChange: (page) => setPage(page),
        }}
      />
      <CreateConceptModal
        open={createModalOpen}
        setOpen={setCreateModalOpen}
        onCreated={() => conceptsQuery.refetch()}
      />
    </div>
  );
};
